<div class="form-modal">
  <h1 mat-dialog-title>{{'RECEPTIONS' | translate}}</h1>
  <div mat-dialog-content>
    <div class="col-md-12 col-sm-12 spacer-bottom-xs"></div>
    <div class="col-lg-12 col-md-12 col-sm-12 no-padding" *ngIf="groupedOrderPods && groupedOrderPods.length > 0">
      <div *ngFor="let orderPod of groupedOrderPods; let i=index">
        <div style="width:100%">
          <div style="padding-top: 10px;" [ngStyle]="{'padding-right': orderPod.Exported ? '10px' : '27px' }">
            <mat-checkbox 
              *ngIf="orderPod.Exported"
              [disabled]="!orderPod.Exported" 
              [(ngModel)]="orderPod.Checked" (change)="onChangeChecked()">{{'RE_EXPORTATION' | translate}}</mat-checkbox>
          </div>
          <div style="flex-basis: 900px">
            <panel [id]="i" [title]="getPanelTitle(orderPod)" [expanded]="false">
              <div *ngIf="orderPod.Details && orderPod.Details.length > 0" class="table table-bordered display"
                cellspacing="0">
                <table class="reception-table">
                  <thead>
                    <tr>
                      <!-- <th width="10%"><strong>{{'RECEPTION_NUMBER'|translate}}</strong></th> -->
                      <th width="10%"><strong>{{'EARLIEST_RECEPTION_DATE'|translate}}</strong></th>
                      <th *ngIf="!hideReceptionNumber" width="10%">
                        <strong *ngIf="!otisReceptionNumberValidation">{{'RECEPTION_NUMBER'|translate}}</strong>
                        <strong *ngIf="otisReceptionNumberValidation">{{'RECEPTION_NUMBER_MENU'|translate}}</strong>
                      </th>
                      <th width="5%"><strong>{{'GUIDE_NUMBER'|translate}}</strong></th>
                      <th width="5%"><strong>#</strong></th>
                      <th width="5%"><strong>{{'ARTICLE'|translate}}</strong></th>
                      <th width="35%"><strong>{{'DESCRIPTION'|translate}}</strong></th>
                      <th *ngIf="showUOMCodeOnReception" width="10%"><strong>{{'UNIT_DATATABLE_HEAD'|translate}}</strong></th>
                      <th width="10%"><strong>{{'ORDERED_QUANTITY'|translate}}</strong></th>
                      <th width="10%"><strong>{{'RECEIVED_QUANTITY'|translate}}</strong></th>
                      <th width="10%" *ngIf="showReturnedQuantity"><strong>{{'RETURNED_QUANTITY'|translate}}</strong></th>
                      <th width="10%" *ngIf="showReturnReasons"><strong>{{'REASON_FOR_RETURN'|translate}}</strong></th>
                      <th width="35%" *ngIf="showCreatedBy"><strong>{{'CREATED_BY'|translate}}</strong></th>
                      <th *ngIf="showCloseLine" width="5%"><strong>{{'LINE_CLOSED'|translate}}</strong></th>
                      <th width="5%"><strong>{{'OBS_ABBREVIATION'|translate}}</strong></th>
                      <th width="5%"></th>
                    </tr>
                  </thead>
                  <tbody *ngFor="let reception of orderPod.Details; let j=index">
                    <tr>
                      <!-- <td>
                                      {{reception.OrderStatusReportNumber}}
                                  </td> -->
                      <td>
                        {{reception.OrderStatusReportDate}}
                      </td>
                      <td *ngIf="!hideReceptionNumber">
                        {{reception.BuyerReceptionNumber}}
                      </td>
                      <td>
                        {{reception.TransportDocumentNumber}}
                      </td>
                      <td>
                        {{reception.OriginalLineNumber}}
                      </td>
                      <td>
                        {{reception.BuyerProductCode}}
                      </td>
                      <td>
                        {{reception.ProductDescription}}
                      </td>
                      <td *ngIf="showUOMCodeOnReception">
                        {{reception.OrderedQuantityUOMCode}}
                      </td>
                      <td>
                        {{reception.RequestedQuantity}}
                      </td>
                      <td>
                        {{reception.DeliveredQuantity}}
                      </td>
                      <td *ngIf="showReturnedQuantity">
                        {{reception.ReturnedQuantity}}
                      </td>
                      <td *ngIf="showReturnReasons">
                        {{reception.ReturnReasonName}}
                      </td>
                      <td *ngIf="showCreatedBy">
                        {{reception.CreatedByName}}
                      </td>
                      <td class="text-center" *ngIf="showCloseLine">
                        <i id="close-icon-{{i}}-{{j}}" class="fas purple_icon backwhite"
                              [ngClass]="{'fa fa-check': reception.Closed, '': !reception.Closed}"></i>
                      </td>
                      <td class="text-center">
                        <button type="button" class="btn btn-sm" (click)="reception.isOpen = !reception.isOpen">
                          <span>
                            <i id="obs-icon-{{i}}-{{j}}" class="fas purple_icon backwhite"
                              [ngClass]="{'fa-folder-open': reception.Notes != null && reception.Notes != '', 'fa-folder': reception.Notes == null || reception.Notes == ''}"></i>
                          </span>
                        </button>
                      </td>
                      <td class="text-center">
                        <button type="button" class="btn btn-sm"
                          (click)="editOrConsultReception(reception)">
                          <span>
                            <i *ngIf="reception.Editable" class="fas fa-pencil-alt color-warning backwhite"></i>
                            <i *ngIf="!reception.Editable" class="fas fa-search-plus color-primary backwhite"></i>
                          </span>
                        </button>
                      </td>
                    </tr>
                    <tr *ngIf="reception.isOpen">
                      <td colspan="11">
                        <span style="white-space: pre-line">{{reception.Notes}}</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </panel>
          </div>

        </div>
      </div>
    </div>
  </div>
  <div mat-dialog-actions>
    <div class="full-width text-right">
      <button type="button" class="btn btn-default" (click)="dialogRef.close(null)">
        <i class="fas fa-ban"></i>&nbsp;{{'BUTTON.CANCEL' | translate}}
      </button>
      <button *ngIf="!hideButtonExport" id="btnChecked" type="button" class="btn btn-primary" disabled (click)="reExportOrderPods()">
        <i class="fas fa-sync-alt"></i>&nbsp;{{'EXPORT' | translate}}
      </button>
    </div>
  </div>
</div>